export enum ChecklistDamagePosition {
  right_rearview = 'domain.enums.checklist_position.right_rearview',
  left_rearview = 'domain.enums.checklist_position.left_rearview',
  right_front_light = 'domain.enums.checklist_position.right_front_light',
  left_front_headlamp = 'domain.enums.checklist_position.left_front_headlamp',
  rear_rear_light_right = 'domain.enums.checklist_position.rear_rear_light_right',
  rear_light_light_left = 'domain.enums.checklist_position.rear_light_light_left',
  front_plate = 'domain.enums.checklist_position.front_plate',
  trunk_cover = 'domain.enums.checklist_position.trunk_cover',
  rear_bumper = 'domain.enums.checklist_position.rear_bumper',
  front_bumper = 'domain.enums.checklist_position.front_bumper',
  right_front_door = 'domain.enums.checklist_position.right_front_door',
  left_front_door = 'domain.enums.checklist_position.left_front_door',
  rear_right_door = 'domain.enums.checklist_position.rear_right_door',
  left_rear_door = 'domain.enums.checklist_position.left_rear_door',
  right_front_fender = 'domain.enums.checklist_position.right_front_fender',
  left_front_fender = 'domain.enums.checklist_position.left_front_fender',
  rear_right_fender = 'domain.enums.checklist_position.rear_right_fender',
  left_rear_fender = 'domain.enums.checklist_position.left_rear_fender',
  wheel_rear_right_tire = 'domain.enums.checklist_position.wheel_rear_right_tire',
  wheel_rear_left_tire = 'domain.enums.checklist_position.wheel_rear_left_tire',
  wheel_front_right_tire = 'domain.enums.checklist_position.wheel_front_right_tire',
  wheel_front_left_tire = 'domain.enums.checklist_position.wheel_front_left_tire',
  hood = 'domain.enums.checklist_position.hood',
  roof = 'domain.enums.checklist_position.roof',
  windshield = 'domain.enums.checklist_position.windshield',
  rear_window = 'domain.enums.checklist_position.rear_window',
  rear_right_side_glass = 'domain.enums.checklist_position.rear_right_side_glass',
  front_right_side_glass = 'domain.enums.checklist_position.front_right_side_glass',
  rear_left_side_glass = 'domain.enums.checklist_position.rear_left_side_glass',
  front_left_side_glass = 'domain.enums.checklist_position.front_left_side_glass',
  small_front_side_glass = 'domain.enums.checklist_position.small_front_side_glass',
  small_left_side_glass = 'domain.enums.checklist_position.small_left_side_glass',
}

export const checklistDamages = [
  {
    value: 'domain.enums.checklist_damages.kneaded',
    label: 'AMASSADO',
    acronym: 'A',
  },
  {
    value: 'domain.enums.checklist_damages.broken',
    label: 'QUEBRADO',
    acronym: 'Q',
  },
  {
    value: 'domain.enums.checklist_damages.torn',
    label: 'RASGADO',
    acronym: 'G',
  },
  {
    value: 'domain.enums.checklist_damages.scratched',
    label: 'RISCADO',
    acronym: 'R',
  },
  {
    value: 'domain.enums.checklist_damages.cracked',
    label: 'TRINCADO',
    acronym: 'T',
  },
  {
    value: 'domain.enums.checklist_damages.hooked',
    label: 'FURADO',
    acronym: 'F',
  },
  {
    value: 'domain.enums.checklist_damages.dirty',
    label: 'SUJO',
    acronym: 'S',
  },
  {
    value: 'domain.enums.checklist_damages.surface_scratch',
    label: 'ARRANHÃO SUPERFICIAL',
    acronym: 'AS',
  },
  {
    value: 'domain.enums.checklist_damages.deep_scratch',
    label: 'ARRANHÃO PROFUNDO',
    acronym: 'AP',
  },
  {
    value: 'domain.enums.checklist_damages.bird_feces_insect_stain',
    label: 'FEZES DE AVES / MANCHA DE INSETO',
    acronym: 'FA',
  },
  {
    value: 'domain.enums.checklist_damages.rough_paint',
    label: 'PINTURA ÁSPERA',
    acronym: 'PA',
  },
  {
    value: 'domain.enums.checklist_damages.over_spray',
    label: 'OVER SPRAY',
    acronym: 'OS',
  },
  {
    value: 'domain.enums.checklist_damages.acid_rain',
    label: 'CHUVA ÁCIDA',
    acronym: 'CA',
  },
  {
    value: 'domain.enums.checklist_damages.sandpaper_marks',
    label: 'MARCAS DE LIXA',
    acronym: 'ML',
  },
  {
    value: 'domain.enums.checklist_damages.stone_beat',
    label: 'BATIDO DE PEDRA',
    acronym: 'BP',
  },
  {
    value: 'domain.enums.checklist_damages.varnish_removal',
    label: 'DESPLACAMENTO DE VERNIZ',
    acronym: 'DV',
  },
  {
    value: 'domain.enums.checklist_damages.ferrous_contamination',
    label: 'CONTAMINAÇÃO FERROSA',
    acronym: 'CF',
  },
  {
    value: 'domain.enums.checklist_damages.frame_loose_frame',
    label: 'MOLDURA / FRISO SOLTO',
    acronym: 'MF',
  },
  {
    value: 'domain.enums.checklist_damages.unknown_defect',
    label: 'DEFEITO DESCONHECIDO',
    acronym: 'DD',
  },
  {
    value: 'domain.enums.checklist_damages.painting_without_adherence',
    label: 'PINTURA SEM ADERÊNCIA',
    acronym: 'PSA',
  },
  {
    value: 'domain.enums.checklist_damages.plotting_aluce',
    label: 'COLA DE PLOTAGEM',
    acronym: 'CP',
  },
  {
    value: 'domain.enums.checklist_damages.repainting_with_color_difference',
    label: 'REPINTURA COM DIFERENÇA DE COR',
    acronym: 'RDC',
  },
  {
    value: 'domain.enums.checklist_damages.poorly_cured_varnish',
    label: 'VERNIZ MAL CURADO',
    acronym: 'V',
  },
  {
    value: 'domain.enums.checklist_damages.ceramic_varnish',
    label: 'VERNIZ CERÂMICO',
    acronym: 'VC',
  },
  {
    value: 'domain.enums.checklist_damages.conventional_varnish',
    label: 'VERNIZ CONVENCIONAL',
    acronym: 'VCC',
  },
  {
    value: 'domain.enums.checklist_damages.coach_application',
    label: 'APLICAÇÃO DE COACH',
    acronym: 'AC',
  },
  {
    value: 'domain.enums.checklist_damages.damaged_leather',
    label: 'COURO DANIFICADO',
    acronym: 'CD',
  },
  {
    value: 'domain.enums.checklist_damages.stain_on_the_carpet',
    label: 'MANCHA NO CARPETE',
    acronym: 'MC',
  },
];
